import React from "react";
import MyCommunitiesContainer from "../../Containers/MyCommunities";

function MyCommunities() {
  return <MyCommunitiesContainer />;
}

export default MyCommunities;
